import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box } from 'reflexbox/styled-components'

import media from 'media'
import theme from 'theme'

import Tag from 'components/blog/Tag'
import Author from 'components/blog/Author'
import ArrowLink from 'components/ArrowLink'

export const Title = styled(Box)``

const StyledTag = styled(Tag).attrs({
  className: 'title-containter-tag',
})`
  margin-top: 30px;

  ${media.giant`
    margin-top: 0;
  `}
`

export const Headline = styled.h1.attrs({ itemProp: 'name headline' })`
  margin: 30px 0;
  font-size: 28px !important;

  ${media.tablet`
    font-size: 36px !important;
  `}
`

const summaryMargin = 35
const Summary = styled(Box).attrs({
  fontSize: theme.fontSizes[40],
  color: theme.colors.black,
  mt: summaryMargin,
  mb: [summaryMargin, summaryMargin, summaryMargin, summaryMargin, 0],
})``
const TitleContainer = ({
  title,
  author,
  date,
  summary,
  tagline,
  className,
  selectedTag,
  link: { to, text },
  renderBottom,
  ...others
}) => {
  return (
    <Title className={className} {...others}>
      <StyledTag>{selectedTag}</StyledTag>
      <Headline itemProp="name headline">{title}</Headline>
      {author && <Author author={author} date={date} showImage />}
      <Summary>{summary.reactComponent || tagline}</Summary>
      {renderBottom && renderBottom()}
      <ArrowLink
        to={to}
        direction="left"
        style={{ marginBottom: '64px', marginTop: '40px' }}
      >
        {text}
      </ArrowLink>
    </Title>
  )
}

export default TitleContainer

TitleContainer.propTypes = {
  title: PropTypes.string,
  author: PropTypes.string,
  date: PropTypes.string,
  summary: PropTypes.string,
  tagline: PropTypes.string,
  className: PropTypes.string,
  selectedTag: PropTypes.string,
}
